import { LoadPlataformasProps } from 'pages/Home/HomeManager'
import HttpClient from './HttpClient'

class PlataformaService {
  async getPlataformas(
    { ignorarPermissao, buscarPrivados }: LoadPlataformasProps,
    userParams?: URLSearchParams
  ) {
    const url = `plataformas`

    const params = new URLSearchParams(userParams)
    if (ignorarPermissao !== undefined)
      params.append('ignorarPermissao', String(ignorarPermissao))
    if (buscarPrivados !== undefined)
      params.append('buscarPrivados', String(buscarPrivados))

    return HttpClient.get(`${url}?${params.toString()}`)
  }

  async getPlataforma(codPlataforma?: string) {
    const url = `plataformas/codigo/${codPlataforma}`

    return await HttpClient.get(url)
  }

  async getPlataformaPorNomeHost(nomeHost?: string) {
    const url = `plataformas/nome-host/${nomeHost}`

    return await HttpClient.get(url)
  }

  async getMenusPlataforma(codPlataforma?: string) {
    const url = `plataformas/codigo/${codPlataforma}/menu`

    return await HttpClient.get(url)
  }
}

export default new PlataformaService()
